// NumberRangeFilter.jsx — debounced min/max numeric range, emits { min, max }.
import React, { useState, useEffect, useRef } from "react";
import { debounce } from "lodash";

const NumberRangeFilter = ({ column, handleInputFilterChangeNoDebounce }) => {
   const val = column?.value || {};
   const [min, setMin] = useState(val.min ?? "");
   const [max, setMax] = useState(val.max ?? "");

   useEffect(() => {
      setMin(val.min ?? "");
      setMax(val.max ?? "");
   }, [column?.value]);

   const debouncedRef = useRef(
      debounce((id, v) => handleInputFilterChangeNoDebounce(id, v), 300)
   );
   useEffect(() => {
      const d = debouncedRef.current;
      return () => d.cancel();
   }, []);

   const emit = (nextMin, nextMax) =>
      debouncedRef.current(column.id, { min: nextMin, max: nextMax });

   return (
      <div className="d-flex gap-1 mt-2">
         <input className="form-control" type="number" placeholder="Min" value={min}
            onChange={(e) => { setMin(e.target.value); emit(e.target.value, max); }} />
         <input className="form-control" type="number" placeholder="Max" value={max}
            onChange={(e) => { setMax(e.target.value); emit(min, e.target.value); }} />
      </div>
   );
};
export default NumberRangeFilter;
